/**
 * PostHog Analytics & Feature Flags
 *
 * Setup:
 * 1. Create a PostHog account at https://posthog.com
 * 2. Create a feature flag named "landing_color_scheme" with variants: "blue" (control), "purple"
 * 3. Add REACT_APP_POSTHOG_KEY to your environment
 */

import posthog from 'posthog-js';

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';

// Initialize PostHog
export const initPostHog = () => {
  if (POSTHOG_KEY && typeof window !== 'undefined') {
    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      autocapture: true,
      capture_pageview: true,
      capture_pageleave: true,
      persistence: 'localStorage',
      // Feature flags bootstrap - default to blue
      bootstrap: {
        featureFlags: {
          'landing_color_scheme': 'blue'
        }
      }
    });
    return true;
  }
  return false;
};

// Get PostHog instance
export const getPostHog = () => {
  if (POSTHOG_KEY) {
    return posthog;
  }
  return null;
};

// Track custom events
export const trackEvent = (eventName, properties = {}) => {
  if (POSTHOG_KEY) {
    posthog.capture(eventName, properties);
  }
};

// Get feature flag value
export const getFeatureFlag = (flagName, defaultValue = null) => {
  if (POSTHOG_KEY) {
    return posthog.getFeatureFlag(flagName) ?? defaultValue;
  }
  return defaultValue;
};

// Identify user for feature flags
export const identifyUser = (userId, properties = {}) => {
  if (POSTHOG_KEY) {
    posthog.identify(userId, properties);
  }
};

export default posthog;
